import React, { useMemo } from 'react';
import classNames from 'classnames';
import SpinLogo from './SpinLogo/index.js';
import Spin from './Spin/index.js';
import Dot from './Dot/index.js';
import './index.less.js';

var TiSpin = function TiSpin(props) {
  var _a;
  var _b = props.presetStyle,
    presetStyle = _b === void 0 ? 'spin' : _b,
    _c = props.size,
    size = _c === void 0 ? 'large' : _c,
    _d = props.loading,
    loading = _d === void 0 ? false : _d,
    children = props.children;
  var isNestedPattern = useMemo(function () {
    return typeof children !== 'undefined';
  }, [children]);
  var spinElement = useMemo(function () {
    switch (presetStyle) {
      case 'spin-logo':
        return /*#__PURE__*/React.createElement(SpinLogo, {
          size: size
        });
      case 'spin':
        return /*#__PURE__*/React.createElement(Spin, {
          size: size
        });
      case 'dot':
        return /*#__PURE__*/React.createElement(Dot, {
          size: size
        });
    }
  }, [size]);
  if (isNestedPattern) {
    var contentCls = classNames((_a = {}, _a['ti-spin-nested-blur'] = loading, _a['ti-spin-nested-container'] = true, _a));
    return /*#__PURE__*/React.createElement("div", {
      className: "ti-spin-nested"
    }, loading && /*#__PURE__*/React.createElement("div", {
      className: "ti-spin-nested-loading"
    }, spinElement), /*#__PURE__*/React.createElement("div", {
      className: contentCls,
      key: "content"
    }, children));
  }
  return spinElement;
};

export { TiSpin as default };
